export enum CellsDataEventObject {
  // Placeholder, remove after adding the first object name.
  PLACEHOLDER_DO_NOT_USE = '__placeholder__',
}
